import React, {Component} from 'react';
import {Link, Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import Dashboard from '../../views/Dashboard/';
import AdminDB from '../../views/Dashboard/AdminDB';
import FieldMasterData from '../../views/Dashboard/FieldMasterData';
import EmailSender from '../../views/Dashboard/EmailSender';
import ReportIssue from '../../views/Dashboard/ReportIssue';
import Documentation from '../../views/Dashboard/Documentation';
import UploadImage from '../../views/Dashboard/UploadImage';

import UserList from '../../views/Users/UserList';
import UserProfile from '../../views/Users/UserProfile';
import ImportUsers from '../../views/Users/ImportUsers';
import ContractorApprovedList from '../../views/Contractors/ApprovedList';
import ContractorNotApprovedList from '../../views/Contractors/NotApprovedList';
import ContractorNotApprovedListUpdate from '../../views/Contractors/NotApprovedListUpdate';
import ContractorProfile from '../../views/Contractors/ContractorProfile';
import ImportContractors from '../../views/Contractors/ImportContractors';

import ProjectApprovedList from "../../views/Projects/ApprovedList";
import ProjectNotApprovedList from "../../views/Projects/NotApprovedList";
import ProjectNotApprovedListUpdate from "../../views/Projects/NotApprovedListUpdate";
import ImportProjects from "../../views/Projects/ImportProject";
import ProjectDetail from "../../views/Projects/ProjectDetail";

// import ListBiddingByProject from "../../views/Bidding/ListByProject";
import BiddingApprovedList from "../../views/Bidding/ApprovedList";
import BiddingNotApprovedList from "../../views/Bidding/NotApprovedList";
import BiddingNotApprovedListUpdate from "../../views/Bidding/NotApprovedListUpdate";
import BiddingDetail from "../../views/Bidding/BiddingDetail";

import ContactList from "../../views/Contacts/ContactList";
import ImportContact from "../../views/Contacts/ImportContact";

import OrderCompletedList from '../../views/Shop/OrderCompletedList';
import OrderWaitingList from '../../views/Shop/OrderWaitingList';
import OrderCanceledList from '../../views/Shop/OrderCanceledList';
import OrderFailedToChargeList from '../../views/Shop/OrderFailedToChargeList';
import OrderInProcessList from '../../views/Shop/OrderInProcessList';
import OrderShippedList from '../../views/Shop/OrderShippedList';

import OrderDetail from '../../views/Shop/OrderDetail';

class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard}/>
                <Route path="/admin-db" name="AdminDB" component={AdminDB}/>
                <Route path="/field-master-data" name="Fied Master Data" component={FieldMasterData}/>
                <Route path="/email-sender" name="Email Sender" component={EmailSender}/>
                <Route path="/report-issue" name="Report Issue" component={ReportIssue}/>
                <Route path="/docs" name="Docs" component={Documentation}/>
                <Route path="/upload-file" name="Upload File" component={UploadImage}/>

                <Route path="/users/list" name="User List" component={UserList}/>
                <Route path="/user/:id" name="User Profile" component={UserProfile}/>
                <Route path="/users/import" name="Import Users" component={ImportUsers}/>

                <Route path="/contractors/list-approved" name="Approved List" component={ContractorApprovedList}/>
                <Route path="/contractors/list-not-approved" name="Not Approved List" component={ContractorNotApprovedList}/>
                <Route path="/contractors/list-not-approved-update" name="Not Approved List" component={ContractorNotApprovedListUpdate}/>
                <Route path="/contractor/:id" name="Contractor Profile" component={ContractorProfile}/>
                <Route path="/contractors/import" name="Import Contractors" component={ImportContractors}/>

                <Route path="/projects/list-approved" name="Approved List" component={ProjectApprovedList}/>
                <Route path="/projects/list-not-approved" name="Not Approved List" component={ProjectNotApprovedList}/>
                <Route path="/projects/list-not-approved-update" name="Not Approved List Update" component={ProjectNotApprovedListUpdate}/>
                <Route path="/projects/import" name="Import Projects" component={ImportProjects}/>
                <Route path="/project/:id" name="Project Detail" component={ProjectDetail}/>

                <Route path="/bidding/list-approved" name="Approved List" component={BiddingApprovedList}/>
                <Route path="/bidding/list-not-approved" name="Approved List" component={BiddingNotApprovedList}/>
                <Route path="/bidding/list-not-approved-update" name="Approved List" component={BiddingNotApprovedListUpdate}/>
                <Route path="/bidding/:id" name="Bidding Detail" component={BiddingDetail}/>

                <Route path="/contacts/list" name="User List" component={ContactList}/>
                <Route path="/contacts/import" name="Import Users" component={ImportContact}/>

                <Route path="/orders/completed" name="Orders Completed List" component={OrderCompletedList} />
                <Route path="/orders/waiting" name="Orders Waiting List" component={OrderWaitingList} />
                <Route path="/orders/canceled" name="Orders Canceled List" component={OrderCanceledList} />
                <Route path="/orders/shipped" name="Orders Shipped List" component={OrderShippedList} />
                <Route path="/orders/failed-to-charge" name="Orders Charge Failed List" component={OrderFailedToChargeList} />
                <Route path="/orders/in-process" name="Orders Charge Failed List" component={OrderInProcessList} />

                <Route path="/order/:id" name="Orders Detail" component={OrderDetail} />

                <Redirect from="/" to="/dashboard"/>
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js